import React, { useState } from "react";
import "../styles/howWeCanHelp.css";
import Accordion from "react-bootstrap/Accordion";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import Card from "react-bootstrap/Card";
import "bootstrap/dist/css/bootstrap.min.css";
import downArrow from "../images/downArrow.png";
import medicalBroad from "../images/howWeCanHelp/medicalBroad.jpg";
import salesBroad from "../images/howWeCanHelp/salesBroad.jpg";
import marketingBroad from "../images/howWeCanHelp/marketingBroad.jpg";
import leadershipBroad from "../images/howWeCanHelp/leadershipBroad.jpg";

const CustomToggle = ({ eventKey }) => {
  const [isOpen, setIsOpen] = useState(false);

  const decoratedOnClick = useAccordionButton(eventKey, () => {
    setIsOpen(!isOpen);
  });

  return (
    <button onClick={decoratedOnClick} className="custom-toggle-button">
      <img
        src={downArrow}
        alt="Down Arrow"
        className={isOpen ? "rotated" : ""}
      />
    </button>
  );
};

const HowWeCanHelp = ({
  salesData,
  marketingData,
  medicalData,
  leadershipData,
}) => {
  return (
    <>
      <section className="product-landing">
        <h1>Transform Your Teams</h1>
        <h3>
          We partner with you to understand your specific goals and challenges
          and customise solutions that suit your unique needs, your culture and
          deliver maximum impact on your performance.
        </h3>
        <div className="product-landing-items-wrap">
          <button className="product-landing-item">
            <a href="#product-sales" className="product-landing-link">
              <div className="product-landing-item-img">
                <img src={salesBroad} alt="Laptop with notes on." />
              </div>
              <div className="product-landing-item-content">
                <h4>
                  <span className="landing-sales">Sales Teams</span>
                </h4>
              </div>
            </a>
          </button>
          <button className="product-landing-item">
            <a href="#product-medical" className="product-landing-link">
              <div className="product-landing-item-img">
                <img src={medicalBroad} alt="Scientist" />
              </div>
              <div className="product-landing-item-content">
                <h4>
                  <span className="landing-medical">Medical Teams</span>
                </h4>
              </div>
            </a>
          </button>
          <button className="product-landing-item">
            <a href="#product-marketing" className="product-landing-link">
              <div className="product-landing-item-img">
                <img src={marketingBroad} alt="People looking at notes" />
              </div>
              <div className="product-landing-item-content">
                <h4>
                  <span className="landing-marketing">Marketing Teams</span>
                </h4>
              </div>
            </a>
          </button>
          <button className="product-landing-item">
            <a href="#product-leadership" className="product-landing-link">
              <div className="product-landing-item-img">
                <img src={leadershipBroad} alt="Person talking" />
              </div>
              <div className="product-landing-item-content">
                <h4>
                  <span className="landing-leadership">Leadership Teams</span>
                </h4>
              </div>
            </a>
          </button>
        </div>
      </section>

      <section className="products">
        <section className="product-sales" id="product-sales">
          <h1>
            Transform your <span className="highlighted-text">sales</span> teams
          </h1>
          <div className="product-items-wrap">
            {salesData.map(({ id, img, name, description }) => (
              <div className="product-item" key={id}>
                <div className="product-item-img">
                  <img src={img} alt="Sales" />
                </div>
                <div className="product-item-content">
                  <Accordion>
                    <Card>
                      <Card.Header>
                        <h2>{name}</h2>
                        <CustomToggle eventKey="0" />
                      </Card.Header>
                      <Accordion.Collapse eventKey="0">
                        <Card.Body>{description}</Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  </Accordion>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="product-medical" id="product-medical">
          <h1>
            Transform your <span className="highlighted-text">medical</span>{" "}
            teams
          </h1>
          <div className="product-items-wrap">
            {medicalData.map(({ id, img, name, description }) => (
              <div className="product-item" key={id}>
                <div className="product-item-img">
                  <img src={img} alt="medical" />
                </div>
                <Accordion flush>
                  <Card>
                    <Card.Header>
                      <h2>{name}</h2>
                      <CustomToggle eventKey="1" />
                    </Card.Header>
                    <Accordion.Collapse eventKey="1">
                      <Card.Body>{description}</Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
            ))}
          </div>
        </section>

        <section className="product-marketing" id="product-marketing">
          <h1>
            Transform your <span className="highlighted-text">marketing</span>{" "}
            teams
          </h1>
          <div className="product-items-wrap">
            {marketingData.map(({ id, img, name, description }) => (
              <div className="product-item" key={id}>
                <div className="product-item-img">
                  <img src={img} alt="marketing" />
                </div>
                <Accordion flush>
                  <Card>
                    <Card.Header>
                      <h2>{name}</h2>
                      <CustomToggle eventKey="2" />
                    </Card.Header>
                    <Accordion.Collapse eventKey="2">
                      <Card.Body>{description}</Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
            ))}
          </div>
        </section>

        <section className="product-leadership" id="product-leadership">
          <h1>
            Transform your{" "}
            <span className="highlighted-text-leadership">leadership</span>{" "}
            teams
          </h1>
          <div className="product-items-wrap">
            {leadershipData.map(({ id, img, name, description }) => (
              <div className="product-item" key={id}>
                <div className="product-item-img">
                  <img src={img} alt="leadership" />
                </div>
                <Accordion flush>
                  <Card>
                    <Card.Header>
                      <h2>{name}</h2>
                      <CustomToggle eventKey="3" />
                    </Card.Header>
                    <Accordion.Collapse eventKey="3">
                      <Card.Body>{description}</Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
            ))}
          </div>
        </section>
      </section>
    </>
  );
};

export default HowWeCanHelp;
